var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-share_Android-solid-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-share_Android-solid-16-2",
    "data-name": "LUI-icon-pd-share_Android-solid-16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,12a2,2,0,0,1-4,0,2.06,2.06,0,0,1,0-.26L5.23,9.57a2,2,0,1,1,0-3.14L9,4.26A2.06,2.06,0,0,1,9,4a2,2,0,1,1,.77,1.57L6,7.74A2.06,2.06,0,0,1,6,8a2.06,2.06,0,0,1,0,.26l3.8,2.17A2,2,0,0,1,13,12Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7a8c952d242ba7751d2481c825546415.svg";
export { ForwardRef as ReactComponent };